import React from 'react';
import { Icon } from '../ui/Icon.jsx';
import { centsToReais } from '../utils/masks.js';
import { getVocabulary, frequencyAdjective } from '../utils/vocabulary.js';
import { resolveChargedAmount } from '../utils/processingCost.js';

const SHARE_BUTTONS = [
  {
    key: 'facebook',
    icon: 'facebook',
    label: 'Compartilhar no Facebook',
    getUrl: (text) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}&quote=${encodeURIComponent(text)}`
  },
  {
    key: 'twitter',
    icon: 'x',
    label: 'Compartilhar no X',
    getUrl: (text) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`
  },
  {
    key: 'linkedin',
    icon: 'linkedin',
    label: 'Compartilhar no LinkedIn',
    getUrl: (text) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`
  },
  {
    key: 'email',
    icon: 'email',
    label: 'Compartilhar por e-mail',
    getUrl: (text, subject) => `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`
  }
];

/**
 * Confirmation step — success banner, party emoji, share buttons, close link.
 * Works for both 'Donation' and 'Lead' goals.
 */
export function ConfirmationStep({ config, formData, onClose, showClose = true }) {
  const { Goal } = config.Behaviour;
  const isDonation = Goal === 'Donation';
  const vocab = getVocabulary(config);

  const firstName = (formData.donorInfo?.Name || '').split(' ')[0];
  const amount    = resolveChargedAmount(config, formData);
  const freqLabel = frequencyAdjective(formData.frequencyId, vocab);

  // Same tokens the editor offers in the thank-you message menu.
  const ThankYouMessage = (config.Behaviour.ThankYouMessage || '')
    .replaceAll('#NOME#', formData.donorInfo?.Name || '')
    .replaceAll('#P_NOME#', firstName)
    .replaceAll('#VALOR#', isDonation ? `R$ ${centsToReais(amount, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '')
    .replaceAll('#FREQUENCIA#', isDonation ? freqLabel : '');

  const shareText = isDonation
    ? `Acabei de fazer ${vocab.an} ${vocab.term} ${freqLabel} de R$${centsToReais(amount)}! Junte-se a mim nesta causa.`
    : `Acabei de me cadastrar nesta causa incrível. Junte-se a mim!`;
  const shareSubject = isDonation
    ? `Fiz ${vocab.an} ${vocab.term}!`
    : 'Junte-se a esta causa!';

  function openShare(getUrl) {
    window.open(getUrl(shareText, shareSubject), '_blank', 'noopener,width=600,height=480');
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="tdw-confirm-body">
        <div className="tdw-confirm-icon">
          <Icon name="checkCircle" size={64} />
        </div>

        <h2 className="tdw-confirm-title">
          {firstName ? `Obrigado, ${firstName}!` : 'Obrigado!'}
        </h2>

        <p className="tdw-confirm-subtitle">
          {isDonation
            ? <>Você fez {vocab.an} {vocab.term} {freqLabel} de <span className="tdw-money">R$ {centsToReais(amount, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>.</>
            : ThankYouMessage
          }
        </p>

        {isDonation && ThankYouMessage && (
          <p className="tdw-confirm-subtitle">{ThankYouMessage}</p>
        )}

        <div style={{ flex: 1 }} />

        <p className="tdw-confirm-share-title">
          {isDonation ? `Compartilhe ${vocab.your} ${vocab.term}` : 'Compartilhe esta causa'}
        </p>

        <div className="tdw-confirm-share-btns">
          {SHARE_BUTTONS.map(btn => (
            <button
              key={btn.key}
              type="button"
              className="tdw-share-btn"
              aria-label={btn.label}
              onClick={() => openShare(btn.getUrl)}
            >
              <Icon name={btn.icon} size={18} />
            </button>
          ))}
        </div>

        {showClose && (
          <button type="button" className="tdw-btn-link" onClick={onClose}>
            Fechar
          </button>
        )}
      </div>
    </div>
  );
}
